/**
 * @generated SignedSource<<87b345a81d7b972966ccb25a6e52974a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobApplicationStatus = "deleted" | "freelancer_not_interested" | "hired" | "interview" | "job_application_draft" | "job_application_invited" | "job_application_sent" | "job_viewed" | "offer" | "potential" | "rejected" | "screening_completed" | "screening_rejected" | "screening_requested" | "screening_started";
export type RateMode = "day" | "hour" | "month" | "week" | "year";
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
export type ApplyToJobInput = {
  clientMutationId?: string | null | undefined;
  jobId: string;
  ref?: string | null | undefined;
  refererUrl?: string | null | undefined;
  status?: JobApplicationStatus | null | undefined;
};
export type job_ApplyToJobMutation$variables = {
  input: ApplyToJobInput;
};
export type job_ApplyToJobMutation$data = {
  readonly applyToJob: {
    readonly jobApplication: {
      readonly freelancer: {
        readonly profile: {
          readonly currency: {
            readonly code: string | null | undefined;
          } | null | undefined;
          readonly freelancerRate: {
            readonly value: number;
          } | null | undefined;
          readonly rateMode: RateMode | null | undefined;
        } | null | undefined;
        readonly status: UserStatus | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"LoggedInNavigationMenu_User">;
      } | null | undefined;
      readonly id: string;
      readonly job: {
        readonly id: string;
      } | null | undefined;
      readonly status: JobApplicationStatus;
      readonly " $fragmentSpreads": FragmentRefs<"JobFooter_JobApplication" | "JobHeader_JobApplication" | "JobSpecConfirmationDialog_JobApplication" | "useJobApplication_JobApplication">;
    } | null | undefined;
  } | null | undefined;
};
export type job_ApplyToJobMutation = {
  response: job_ApplyToJobMutation$data;
  variables: job_ApplyToJobMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "freelancerRate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rateMode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Currency",
  "kind": "LinkedField",
  "name": "currency",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileJobIncompatibilityReasons",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = [
  (v10/*: any*/),
  (v2/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupIndex",
  "storageKey": null
},
v13 = [
  "active",
  "paused"
],
v14 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v15 = [
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "paymentsEnabled": true,
      "statuses": (v13/*: any*/)
    }
  },
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v17 = [
  (v16/*: any*/)
],
v18 = {
  "kind": "Literal",
  "name": "filters",
  "value": {
    "statuses": (v13/*: any*/)
  }
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "job_ApplyToJobMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ApplyToJobPayload",
        "kind": "LinkedField",
        "name": "applyToJob",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JobApplication",
            "kind": "LinkedField",
            "name": "jobApplication",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Job",
                "kind": "LinkedField",
                "name": "job",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "freelancer",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Currency",
                        "kind": "LinkedField",
                        "name": "currency",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LoggedInNavigationMenu_User"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "JobHeader_JobApplication"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "JobFooter_JobApplication"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useJobApplication_JobApplication"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "JobSpecConfirmationDialog_JobApplication"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "job_ApplyToJobMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ApplyToJobPayload",
        "kind": "LinkedField",
        "name": "applyToJob",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JobApplication",
            "kind": "LinkedField",
            "name": "jobApplication",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Job",
                "kind": "LinkedField",
                "name": "job",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobApplication",
                    "kind": "LinkedField",
                    "name": "jobApplication",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Firm",
                    "kind": "LinkedField",
                    "name": "firm",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Industry",
                    "kind": "LinkedField",
                    "name": "industry",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "locationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Country",
                    "kind": "LinkedField",
                    "name": "jobCountries",
                    "plural": true,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezoneIdentifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezoneRange",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobsSpecialization",
                    "kind": "LinkedField",
                    "name": "jobsSpecializations",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Specialization",
                        "kind": "LinkedField",
                        "name": "specialization",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rawId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "positionTypes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobSkill",
                    "kind": "LinkedField",
                    "name": "jobSkills",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "required",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "requiredYears",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Skill",
                        "kind": "LinkedField",
                        "name": "skill",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requiredExperienceYears",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "freelancer",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasActivePayoutMethod",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canSetupPayoutMethod",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canViewTaxes",
                    "storageKey": null
                  },
                  {
                    "alias": "contractsWithPayments",
                    "args": (v15/*: any*/),
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "freelancerContracts",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": "freelancerContracts(filters:{\"paymentsEnabled\":true,\"statuses\":[\"active\",\"paused\"]},first:1)"
                  },
                  {
                    "alias": "contractsWithExpenses",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "allowExpensesAccess": true,
                          "statuses": (v13/*: any*/)
                        }
                      },
                      (v14/*: any*/)
                    ],
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "freelancerContracts",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": "freelancerContracts(filters:{\"allowExpensesAccess\":true,\"statuses\":[\"active\",\"paused\"]},first:1)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpenseConnection",
                    "kind": "LinkedField",
                    "name": "expenses",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BonusConnection",
                    "kind": "LinkedField",
                    "name": "freelancerBonuses",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PayoutConnection",
                    "kind": "LinkedField",
                    "name": "payouts",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isClient",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "invitationType": "invitation",
                          "statuses": [
                            "offer_made"
                          ]
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 10
                      }
                    ],
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "freelancerContracts",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContractEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contract",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previousStatus",
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "freelancerContracts(filters:{\"invitationType\":\"invitation\",\"statuses\":[\"offer_made\"]},first:10)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasIndividualWorkspace",
                    "storageKey": null
                  },
                  {
                    "alias": "contractsWithPaymentsOrPendingSignatures",
                    "args": [
                      (v18/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 5
                      }
                    ],
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "freelancerContracts",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContractEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contract",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "paymentsEnabled",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Signature",
                                "kind": "LinkedField",
                                "name": "contractorStatementOfWorkSignature",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "needsSigning",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:5)"
                  },
                  {
                    "alias": "contractsWithTimesheets",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "enableTimesheets": true,
                          "statuses": (v13/*: any*/)
                        }
                      },
                      (v14/*: any*/)
                    ],
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "freelancerContracts",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": "freelancerContracts(filters:{\"enableTimesheets\":true,\"statuses\":[\"active\",\"paused\"]},first:1)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimesheetConnection",
                    "kind": "LinkedField",
                    "name": "freelancerTimesheets",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "contractsWithBonuses",
                    "args": (v15/*: any*/),
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "freelancerContracts",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": "freelancerContracts(filters:{\"paymentsEnabled\":true,\"statuses\":[\"active\",\"paused\"]},first:1)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMember",
                    "storageKey": null
                  },
                  {
                    "alias": "activeContracts",
                    "args": [
                      (v18/*: any*/),
                      (v14/*: any*/)
                    ],
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "freelancerContracts",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
                  },
                  {
                    "alias": "endedContracts",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "paymentsEnabled": true,
                          "statuses": [
                            "deleted",
                            "expired"
                          ]
                        }
                      },
                      (v14/*: any*/)
                    ],
                    "concreteType": "ContractConnection",
                    "kind": "LinkedField",
                    "name": "freelancerContracts",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": "freelancerContracts(filters:{\"paymentsEnabled\":true,\"statuses\":[\"deleted\",\"expired\"]},first:1)"
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileWillUpdateOnApply",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileCompatibleWithJob",
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "df9194e9d54ce8280c344de5bb4ba1d8",
    "id": null,
    "metadata": {},
    "name": "job_ApplyToJobMutation",
    "operationKind": "mutation",
    "text": "mutation job_ApplyToJobMutation(\n  $input: ApplyToJobInput!\n) {\n  applyToJob(input: $input) {\n    jobApplication {\n      id\n      job {\n        id\n      }\n      status\n      freelancer {\n        status\n        profile {\n          freelancerRate {\n            value\n          }\n          currency {\n            code\n            id\n          }\n          rateMode\n          id\n        }\n        ...LoggedInNavigationMenu_User\n        id\n      }\n      ...JobHeader_JobApplication\n      ...JobFooter_JobApplication\n      ...useJobApplication_JobApplication\n      ...JobSpecConfirmationDialog_JobApplication\n    }\n  }\n}\n\nfragment CompensationConfirmation_Job on Job {\n  rateMode\n  freelancerRate {\n    value\n  }\n  currency {\n    code\n    id\n  }\n  jobApplication {\n    profileJobIncompatibilityReasons\n    id\n  }\n}\n\nfragment CompensationConfirmation_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...CompensationConfirmation_Job\n    id\n  }\n}\n\nfragment IndustryMismatch_Job on Job {\n  industry {\n    name\n    id\n  }\n}\n\nfragment IndustryMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...IndustryMismatch_Job\n    id\n  }\n}\n\nfragment JobFooter_JobApplication on JobApplication {\n  status\n}\n\nfragment JobHeader_JobApplication on JobApplication {\n  status\n}\n\nfragment JobSpecConfirmationDialog_JobApplication on JobApplication {\n  status\n  profileCompatibleWithJob\n  profileWillUpdateOnApply\n  ...RateConfirmation_JobApplication\n  ...CompensationConfirmation_JobApplication\n  ...ResumeMismatch_JobApplication\n  ...IndustryMismatch_JobApplication\n  ...LocationMismatch_JobApplication\n  ...SubtypesMismatch_JobApplication\n  ...PositionTypeMismatch_JobApplication\n  ...SkillMismatch_JobApplication\n  ...TotalExperienceMismatch_JobApplication\n}\n\nfragment LocationMismatch_Job on Job {\n  slug\n  firm {\n    slug\n    id\n  }\n  locationType\n  jobCountries {\n    name\n    id\n  }\n  timezoneIdentifier\n  timezoneRange\n}\n\nfragment LocationMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...LocationMismatch_Job\n    id\n  }\n}\n\nfragment LoggedInNavigationMenu_User on User {\n  ...MyAccountNavigationMenu_User\n  ...WorkspaceNavigationMenu_User\n  ...user_useIsMember\n  ...user_shouldForceOfferAccept\n  ...useEnableMyWork_User\n  activeContracts: freelancerContracts(first: 1, filters: {statuses: [active, paused]}) {\n    totalCount\n  }\n  endedContracts: freelancerContracts(first: 1, filters: {statuses: [deleted, expired], paymentsEnabled: true}) {\n    totalCount\n  }\n}\n\nfragment MyAccountNavigationMenu_User on User {\n  hasActivePayoutMethod\n  canSetupPayoutMethod\n  canViewTaxes\n  ...user_canAccessOwnPayments\n  ...user_useIsClient\n  ...user_shouldForceOfferAccept\n}\n\nfragment PositionTypeMismatch_Job on Job {\n  positionTypes\n  jobApplication {\n    profileJobIncompatibilityReasons\n    id\n  }\n}\n\nfragment PositionTypeMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...PositionTypeMismatch_Job\n    id\n  }\n}\n\nfragment RateConfirmation_Job on Job {\n  freelancerRate {\n    value\n  }\n  currency {\n    code\n    id\n  }\n  rateMode\n}\n\nfragment RateConfirmation_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...RateConfirmation_Job\n    id\n  }\n}\n\nfragment ResumeMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    slug\n    firm {\n      slug\n      id\n    }\n    id\n  }\n}\n\nfragment SkillMismatch_Job on Job {\n  ...job_useMismatchingSkillsJob\n}\n\nfragment SkillMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...SkillMismatch_Job\n    id\n  }\n}\n\nfragment SubtypesMismatch_Job on Job {\n  jobsSpecializations {\n    specialization {\n      name\n      id\n    }\n    id\n  }\n  ...job_useMissingSubtypesJob\n}\n\nfragment SubtypesMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...SubtypesMismatch_Job\n    id\n  }\n}\n\nfragment TotalExperienceMismatch_Job on Job {\n  requiredExperienceYears\n  jobApplication {\n    profileJobIncompatibilityReasons\n    id\n  }\n}\n\nfragment TotalExperienceMismatch_JobApplication on JobApplication {\n  profileJobIncompatibilityReasons\n  job {\n    ...TotalExperienceMismatch_Job\n    id\n  }\n}\n\nfragment WorkspaceNavigationMenu_User on User {\n  ...useEnableMyWork_User\n}\n\nfragment job_useMismatchingSkillsJob on Job {\n  jobSkills {\n    required\n    requiredYears\n    groupIndex\n    skill {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment job_useMissingSubtypesJob on Job {\n  jobsSpecializations {\n    groupIndex\n    specialization {\n      id\n      rawId\n      name\n    }\n    id\n  }\n}\n\nfragment useEnableMyWork_User on User {\n  hasIndividualWorkspace\n  ...user_canAccessOwnContracts\n  ...user_canAccessOwnTimesheets\n  ...user_canAccessOwnExpenses\n  ...user_canAccessOwnPayments\n  ...user_canAccessOwnBonuses\n}\n\nfragment useJobApplication_JobApplication on JobApplication {\n  profileWillUpdateOnApply\n  profileCompatibleWithJob\n}\n\nfragment user_canAccessOwnBonuses on User {\n  contractsWithBonuses: freelancerContracts(first: 1, filters: {statuses: [active, paused], paymentsEnabled: true}) {\n    totalCount\n  }\n  freelancerBonuses {\n    totalCount\n  }\n}\n\nfragment user_canAccessOwnContracts on User {\n  contractsWithPaymentsOrPendingSignatures: freelancerContracts(first: 5, filters: {statuses: [active, paused]}) {\n    totalCount\n    edges {\n      node {\n        paymentsEnabled\n        contractorStatementOfWorkSignature {\n          needsSigning\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment user_canAccessOwnExpenses on User {\n  contractsWithExpenses: freelancerContracts(first: 1, filters: {statuses: [active, paused], allowExpensesAccess: true}) {\n    totalCount\n  }\n  expenses {\n    totalCount\n  }\n}\n\nfragment user_canAccessOwnPayments on User {\n  contractsWithPayments: freelancerContracts(first: 1, filters: {statuses: [active, paused], paymentsEnabled: true}) {\n    totalCount\n  }\n  contractsWithExpenses: freelancerContracts(first: 1, filters: {statuses: [active, paused], allowExpensesAccess: true}) {\n    totalCount\n  }\n  expenses {\n    totalCount\n  }\n  freelancerBonuses {\n    totalCount\n  }\n  payouts {\n    totalCount\n  }\n}\n\nfragment user_canAccessOwnTimesheets on User {\n  contractsWithTimesheets: freelancerContracts(first: 1, filters: {statuses: [active, paused], enableTimesheets: true}) {\n    totalCount\n  }\n  freelancerTimesheets {\n    totalCount\n  }\n}\n\nfragment user_isClient on User {\n  status\n  isClient\n}\n\nfragment user_isMember on User {\n  status\n  isMember\n}\n\nfragment user_shouldForceOfferAccept on User {\n  status\n  freelancerContracts(first: 10, filters: {statuses: [offer_made], invitationType: invitation}) {\n    totalCount\n    edges {\n      node {\n        previousStatus\n        id\n      }\n    }\n  }\n}\n\nfragment user_useIsClient on User {\n  ...user_isClient\n}\n\nfragment user_useIsMember on User {\n  ...user_isMember\n}\n"
  }
};
})();

(node as any).hash = "828623f5352081122a71cddcfef2d58b";

export default node;
